function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_60_70)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 48.0346V96.0686H48.034H96.068V48.0346V0.000602722H48.034H0V48.0346Z",
  fill: "#007ACC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.2439 48.3526L21.2134 52.2869L27.4654 52.2869H33.7175V70.0518V87.8168H38.1396H42.5618V70.0518V52.2869H48.8139H55.0659V48.4289C55.0659 46.294 55.0202 44.5099 54.9592 44.4642C54.9134 44.4032 47.3042 44.3727 38.0786 44.3879L21.2896 44.4337L21.2439 48.3526Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.5171 44.3222C79.957 44.9322 81.8173 46.0149 83.5252 47.7837C84.4096 48.7292 85.721 50.4523 85.8278 50.864C85.8583 50.986 81.6801 53.7918 79.1488 55.3624C79.0573 55.4234 78.6913 55.027 78.2796 54.417C77.0444 52.6176 75.7483 51.8399 73.7659 51.7027C70.8534 51.5045 68.9778 53.0294 68.993 55.5759C68.993 56.3231 69.0997 56.7653 69.4047 57.3753C70.0452 58.7019 71.2346 59.4949 74.9706 61.1113C81.8478 64.0695 84.7909 66.0214 86.6207 68.7967C88.6641 71.8922 89.1215 76.8329 87.7339 80.5079C86.209 84.5031 82.4273 87.2174 77.1054 88.117C75.4585 88.4068 71.5548 88.361 69.7859 88.0408C65.928 87.3546 62.2682 85.4485 60.0114 82.9477C59.127 81.9717 57.4039 79.4252 57.5106 79.2422C57.5563 79.1812 57.9528 78.9372 58.395 78.678C58.822 78.434 60.4384 77.5038 61.9633 76.6194L64.7233 75.0183L65.3028 75.8722C66.111 77.1073 67.8798 78.8 68.9473 79.3642C72.0123 80.9806 76.221 80.7518 78.2948 78.8915C79.1793 78.0833 79.5452 77.2446 79.5452 76.0094C79.5452 74.8963 79.408 74.4083 78.8285 73.5696C78.0813 72.5022 76.5565 71.6025 72.2258 69.7269C67.2699 67.592 65.135 66.2654 63.1832 64.161C62.0548 62.9411 60.9873 60.9893 60.5451 59.3576C60.1792 58.0005 60.0877 54.6 60.3774 53.2276C61.3991 48.4394 65.013 45.0999 70.2282 44.1088C71.9208 43.7885 75.855 43.9105 77.5171 44.3222Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_60_70"
}, /*#__PURE__*/React.createElement("rect", {
  width: 96.068,
  height: 96.068,
  fill: "white"
})));

var SvgTypescriptLogo = function SvgTypescriptLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTypescriptLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/typescriptLogo.eb0742b4.svg";
export { ForwardRef as ReactComponent };